/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { LoginResultViewModel } from "../types/LoginResultViewModel.ts";
import { loginResultCompanyViewModelSchema } from "./loginResultCompanyViewModelSchema.ts";
import { userControllerPermissionLoginViewModelSchema } from "./userControllerPermissionLoginViewModelSchema.ts";

export const loginResultViewModelSchema = z.object({
  token: z
    .string()
    .describe("Token de autenticação JWT gerado após o login bem-sucedido.")
    .nullish(),
  tokenId: z
    .string()
    .describe("Identificador único do token emitido.")
    .nullish(),
  tokenExpireDate: z.optional(
    z
      .string()
      .datetime()
      .describe("Data de expiração do token de autenticação."),
  ),
  name: z.string().describe("Nome completo do usuário autenticado.").nullish(),
  userName: z
    .string()
    .describe("Nome de usuário utilizado na autenticação.")
    .nullish(),
  userId: z.optional(z.number().int().describe("ID do usuário autenticado.")),
  personId: z.optional(
    z.number().int().describe("ID da pessoa vinculada ao usuário autenticado."),
  ),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa do contexto de autenticação. Opcional.")
    .nullish(),
  email: z
    .string()
    .describe("Endereço de e-mail do usuário autenticado.")
    .nullish(),
  language: z
    .string()
    .describe("Idioma preferencial do usuário (código de cultura, ex: pt-BR).")
    .nullish(),
  accessType: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo de acesso utilizado na autenticação. Enum EUserAccessType: `0` = Web, `1` = Mobile, `2` = Integration.",
      ),
  ),
  profile: z.optional(
    z
      .number()
      .int()
      .describe(
        "Perfil de acesso global do usuário. Enum EUserRole: `1` = Master, `2` = Administrator, `3` = Polo, `4` = Basic, `5` = Relationship, `6` = Planning, `7` = Secretary, `8` = Communication, `9` = Financial, `10` = Visitor, `11` = API, `12` = StudentCare, `13` = Valoriza, `14` = Leads, `15` = Faculty, `16` = Orientation, `17` = Exams, `18` = BusinessCore, `19` = Contracts, `20` = HumanResources, `21` = Audiovisual, `22` = ScholarshipTeam, `23` = Translation, `24` = Transmission, `25` = RelationshipTR, `26` = International.",
      ),
  ),
  isStudent: z.optional(
    z.boolean().describe("Indica se o usuário possui perfil de aluno."),
  ),
  isMonitor: z.optional(
    z.boolean().describe("Indica se o usuário possui perfil de monitor."),
  ),
  isMonitorTCC: z.optional(
    z
      .boolean()
      .describe("Indica se o usuário possui perfil de monitor de TCC."),
  ),
  isEmployee: z.optional(
    z.boolean().describe("Indica se o usuário possui perfil de funcionário."),
  ),
  isTeachingStaff: z.optional(
    z.boolean().describe("Indica se o usuário pertence ao corpo docente."),
  ),
  passwordChanged: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o usuário já realizou a troca de senha após o primeiro acesso.",
      ),
  ),
  hasCompanyEnrollment: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o usuário possui matrícula vinculada a uma empresa.",
      ),
  ),
  roles: z
    .array(z.string())
    .describe("Lista de roles (perfis de permissão) atribuídos ao usuário.")
    .nullish(),
  companies: z
    .array(z.lazy(() => loginResultCompanyViewModelSchema))
    .describe(
      "Lista de empresas às quais o usuário possui acesso, com o perfil em cada uma.",
    )
    .nullish(),
  classStudents: z
    .array(z.number().int())
    .describe("Lista de IDs de turmas (ClassStudent) vinculadas ao usuário.")
    .nullish(),
  controllerPermissions: z
    .array(z.lazy(() => userControllerPermissionLoginViewModelSchema))
    .describe(
      "Lista de permissões por controller atribuídas individualmente ao usuário.",
    )
    .nullish(),
}) as unknown as ToZod<LoginResultViewModel>;
